import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiHome, FiBriefcase, FiTool, FiLayout } from 'react-icons/fi';

const Services = () => {
  const services = [
    {
      title: 'Residential Design',
      description: 'Transform your house into a home with our bespoke residential interior design services tailored to your taste.',
      icon: FiHome
    },
    {
      title: 'Commercial Spaces',
      description: 'Create inspiring workspaces that boost productivity and reflect your brand identity perfectly.',
      icon: FiBriefcase
    },
    {
      title: 'Renovation',
      description: 'Breathe new life into existing spaces with our comprehensive remodeling and renovation expertise.',
      icon: FiTool
    },
    {
      title: 'Space Planning',
      description: 'Optimize your layout for maximum functionality and flow, ensuring every square foot is utilized efficiently.',
      icon: FiLayout
    }
  ];

  return (
    <section id="services" className="py-24 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-accent font-medium tracking-widest uppercase text-sm mb-2">What We Do</p>
          <h2 className="text-3xl md:text-4xl font-serif text-primary font-bold">Our Expertise</h2>
          <div className="w-24 h-1 bg-accent mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white p-8 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100 group">
              <div className="w-14 h-14 bg-surface rounded-full flex items-center justify-center mb-6 group-hover:bg-accent transition-colors duration-300">
                <SafeIcon icon={service.icon} className="h-6 w-6 text-accent group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="text-xl font-serif font-semibold text-primary mb-3">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;